import 'slick-carousel';
import { getInstance } from './ga4-tracking';
import { loadTurnstile } from './turnstile';

function newsletterSignup() {
  const endpoint =
    (typeof guidedogsGlobals === 'object' &&
      `${guidedogsGlobals.gdresturl}newsletter`) ||
    '';
  const signupForm = document.querySelector('#newsletter-signup-form');
  const newsletterError = document.querySelector('#newsletter-error');
  const tracking = getInstance();

  // eslint-disable-next-line no-unused-vars
  let currentSlide = 0; // 0, 1 or 2, indicating the steps in the form.
  let loading = false;

  if (!signupForm) return;

  const $carouselForm = $('.form-carousel');
  const button = signupForm.querySelector('button[type="submit"]');

  const fixCurrentSlideHeight = () => {
    let actualHeight = $('.slick-current', $carouselForm).height();
    let cssHeight = $('.slick-list', $carouselForm).css('height');

    if (cssHeight === actualHeight.toString() + 'px') {
      return;
    }

    $('.slick-list', $carouselForm).css('height', actualHeight);
  };

  const setError = (message) => {
    newsletterError.textContent = message !== false ? message : '';
    newsletterError.classList.toggle('u-none', message === false);

    if (message) {
      tracking.createEvent('form-event', 'form_error', signupForm);
    }

    fixCurrentSlideHeight();
  };

  const setLoading = (isLoading) => {
    loading = isLoading;
    button.disabled = isLoading;
  };

  // Initialise the carousel that controls.
  $carouselForm.slick({
    arrows: false,
    infinite: false,
    speed: 750,
    adaptiveHeight: true,
    autoplay: false,
    vertical: true,
    swipe: false,
  });

  $carouselForm.on('setPosition', () => {
    fixCurrentSlideHeight();
  });

  $('#newsletter-back').click(() => {
    $carouselForm.slick('slickPrev');
    currentSlide = 0;
  });

  $('[data-next-btn]').click(() => {
    if (signupForm.checkValidity()) {
      $carouselForm.slick('slickNext');
      currentSlide = 1;
    } else {
      $carouselForm.slick(
        'slickGoTo',
        $carouselForm.slick('slickCurrentSlide'),
      );
    }
  });

  // Special treatment for VIC form which contains more fields.
  const $perceptionsOptin = $('#optin-Perceptions');
  const $perceptionsExtras = $('#perceptions-extras');

  if ($perceptionsOptin.length && $perceptionsExtras.length) {
    const $occupation = $('#newsletter-occupation');

    $perceptionsOptin.change((e) => {
      // Set field as required when the Perceptions checkbox is ticked.
      $occupation.attr('required', e.target.checked);
      $perceptionsExtras.toggleClass('u-none', !e.target.checked);

      fixCurrentSlideHeight();
    });
  }

  const newsletterErrorContainer = document.querySelector(
    '[data-js-newsletter-signup-errors]',
  );
  let errorCount = signupForm.querySelectorAll(':invalid');
  const nextBtn = document.querySelector('[data-next-btn]');
  nextBtn &&
    nextBtn.addEventListener('click', () => {
      const invalidItems = signupForm.querySelectorAll('[aria-invalid="true"]');
      invalidItems.forEach((element) => {
        element.setAttribute('aria-invalid', false);
        const errorMessageElement = element
          .closest('.form__row')
          ?.querySelector('.error');
        if (errorMessageElement) {
          errorMessageElement.textContent = '';
        }
      });
      errorCount = signupForm.querySelectorAll(':invalid');
      if (errorCount.length > 0) {
        newsletterErrorContainer.querySelector('ul').innerHTML = '';
        newsletterErrorContainer.classList.remove('u-none');
        signupForm.querySelectorAll(':invalid').forEach((item) => {
          item.setAttribute('aria-invalid', true);
          // Adding validationMessage below the input field
          const errorMessageElement = item
            .closest('.form__row')
            ?.querySelector('.error');
          if (errorMessageElement) {
            errorMessageElement.textContent = item.validationMessage;
          }

          const name = item.getAttribute('placeholder')
            ? item.getAttribute('placeholder')
            : item.getAttribute('data-js-validation-label');
          newsletterErrorContainer
            .querySelector('ul')
            .insertAdjacentHTML(
              'beforeend',
              `<li>${name}: ${item.validationMessage}</li>`,
            );
        });
      } else {
        newsletterErrorContainer.classList.add('u-none');
      }
    });

  signupForm.addEventListener('submit', (e) => {
    e.preventDefault();

    if (loading) {
      return;
    }

    if (signupForm.checkValidity()) {
      // Current slide = 1, last step of the form.
      const checkedOptions = [...signupForm.elements['optins[]']].filter(
        (el) => el.checked,
      );

      if (!checkedOptions.length) {
        setError('Please select at least one newsletter.');
      } else {
        setError(false);

        // Submit the form.
        const checkedValues = checkedOptions.map((checkbox) => checkbox.value);

        const postData = {
          'subscribe-title': signupForm.elements['subscribe-title']
            ? signupForm.elements['subscribe-title'].value
            : '',
          'subscribe-name': signupForm.elements['subscribe-name'].value,
          'subscribe-lastname': signupForm.elements['subscribe-lastname'].value,
          'subscribe-email': signupForm.elements['subscribe-email'].value,
          'subscribe-phone': signupForm.elements['subscribe-phone']
            ? signupForm.elements['subscribe-phone'].value
            : '',
          'subscribe-state': signupForm.elements['subscribe-state']
            ? signupForm.elements['subscribe-state'].value
            : '',
          optins: checkedValues,
        };

        setLoading(true);

        loadTurnstile(
          signupForm.querySelector('[data-turnstile-newsletter]'),
          (token) => {
            postData[guidedogs_turnstile.fieldname] = token;
            fetch(endpoint, {
              method: 'POST',
              body: JSON.stringify(postData),
              headers: {
                'Content-Type': 'application/json',
              },
            })
              .then((response) => response.json())
              .then((response) => {
                if (response !== 'success') {
                  if (response && response.message) {
                    setError(response.message);
                  } else {
                    setError(
                      'An unknown error has occured. Please try again or contact us to resolve this issue.',
                    );
                  }
                } else {
                  document
                    .querySelector('#newsletter-signup-last-step')
                    .classList.add('u-none');
                  document
                    .querySelector('#newsletter-signup-success')
                    .classList.remove('u-none');
                  if (typeof window.dataLayer !== 'undefined') {
                    dataLayer.push({
                      event: signupForm.elements['custom-event-id'].value,
                    });
                  }
                  tracking.createEvent('form-event', 'form_submit', signupForm);
                }
              })
              .finally(() => {
                setLoading(false);
              });
          },
          'newsletter-signup',
        );
      }
    }
  });
}

export function init() {
  newsletterSignup();
}
